module.exports = __webpack_public_path__ + "img/student-card.1151ef39.png";